import { lzmaDecompressor } from './utils/lzmaDecompressor';
import { forEach } from 'ramda';
import rsvp from 'rsvp';

// Simple, persistent api cache for now.
const apiCache = {};
const fetchingCache = {};

export default function apiBase(fetchNext) {
  return (store, { types, url, fireAndForget, payload, queryKey, requestPayload, cache, method, contentType, body, files, success, failure, decompress }) => {
    let urls = Array.isArray(url) ? url : [url];
    if (!contentType) contentType = 'json';
    const [requestType, successType, failureType] = types || ['IGN', 'IGN', 'IGN'];

    // If we provide a 'queryKey', there can be only one query at once
    if (queryKey) {
      if (apiCache[queryKey]) {
        return fireAndForget ? apiCache[queryKey] : Promise.resolve(apiCache[queryKey]);
      }

      if (fetchingCache[queryKey]) {
        if (fireAndForget) {
          fetchingCache[queryKey].push({ payload, store });
          store.dispatch({ type: requestType, payload });
          return;
        } else {
          return new rsvp.Promise((resolve, reject) => {
            fetchingCache[queryKey].push({ payload, store, resolve, reject });
            store.dispatch({ type: requestType, payload });
          });
        }
      }

      fetchingCache[queryKey] = [{ payload, store }];
    }

    store.dispatch({ type: requestType, payload });

    var promise = new rsvp.Promise((resolve, reject) => {
      const meta = {
        queryKey,
        payload,
        successType,
        success,
        failureType,
        failure,
      };

      function onFailure(error, workerMeta) {
        const { failureType, failure, queryKey, payload } = workerMeta || meta;

        if (queryKey) {
          forEach(({ payload, store, reject }) => {
            store.dispatch({ type: failureType, payload, error });
            if (reject) reject(error);
          }, fetchingCache[queryKey]);
          delete fetchingCache[queryKey];
        } else {
          store.dispatch({ type: failureType, payload: payload, error });
        }

        if (failure) failure(error);
        reject(error);
      };

      function onSuccessEnd(buffer, workerMeta) {
        const { successType, sucess, queryKey, payload } = workerMeta || meta;
        if (queryKey) {
          apiCache[queryKey] = buffer;
          forEach(({ payload, store, resolve }) => {
            store.dispatch({ type: successType, payload, response: buffer });
            if (resolve) resolve(buffer);
          }, fetchingCache[queryKey]);
          delete fetchingCache[queryKey];
        } else {
          store.dispatch({ type: successType, payload: payload, response: buffer });
        }

        if (success) success(buffer);
        resolve(buffer);
      }

      function onSuccess(response) {
        if (decompress) {
          lzmaDecompressor(response, meta, onSuccessEnd, onFailure);
        } else {
          onSuccessEnd(response);
        }
      };

      fetchNext(urls[0], urls.slice(1), onSuccess, onFailure, { contentType, method, body, files });
    });

    return fireAndForget ? null : promise;
  };
}




// WEBPACK FOOTER //
// ./src/store/apiBase.js